"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;
require("dotenv/config");
var _commonTypes = require("@abacus/common-types");
var _snowflakeClient = require("@abacus/snowflake-client");
// Load env variables

const environments = new Set(Object.values(_commonTypes.Environment));
const APPLICATION_NAME = "lambda-abacus-adjustment-file-validation";
const IS_DRY_RUN = ["1", "y", "yes", "true"].includes(process.env.IS_DRY_RUN ?? "");

// Auth
const orchardIdentityId = process.env.ORCHARD_IDENTITY_ID ?? "";

// Environment setup
const environment = process.env.ENVIRONMENT ?? "";
const hasEnvironment = environments.has(environment);
const ENVIRONMENT = hasEnvironment ? environment : _commonTypes.Environment.Dev;

// Logging Level
const logLevel = process.env.LOGGING_LEVEL ?? "";
const logLevels = new Set(Object.values(_commonTypes.LogLevel));
const hasLogLevel = logLevels.has(logLevel);
const LOGGER_LEVEL = hasLogLevel ? logLevel : _commonTypes.LogLevel.Info;

// Logger DSN
const LOGGER_DSN = process.env.LOGGER_DSN ?? undefined;

// Cache Size
const cacheSize = parseFloat(process.env.CACHE_SIZE ?? "");
const CACHE_SIZE = Number.isNaN(cacheSize) ? 10000 : Math.max(0, Math.trunc(cacheSize));

// Chunk Size
const chunkSize = parseFloat(process.env.CHUNK_SIZE ?? "");
const CHUNK_SIZE = Number.isNaN(chunkSize) ? 1000 : Math.max(0, Math.trunc(chunkSize));

// S3
const S3_BUCKET_NAME = process.env.S3_BUCKET_NAME ?? "qa-abacus-adjustments";
const config = exports.config = {
  applicationName: APPLICATION_NAME,
  aws: {
    accessKeyId: process.env.AWS_ACCESS_KEY_ID,
    region: process.env.AWS_REGION ?? "us-east-1",
    secretAccessKey: process.env.AWS_SECRET_ACCESS_KEY,
    sessionToken: process.env.AWS_SESSION_TOKEN
  },
  environment: ENVIRONMENT,
  isDryRun: IS_DRY_RUN,
  loggerDSN: LOGGER_DSN,
  loggerLevel: LOGGER_LEVEL,
  cacheSize: CACHE_SIZE,
  chunkSize: CHUNK_SIZE,
  orchardIdentityId: orchardIdentityId,
  s3: {
    bucketName: S3_BUCKET_NAME
  },
  sentry: undefined,
  snowflake: (0, _snowflakeClient.getConfig)()
};